import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LandingPageAppResource from './LandingPageAppResource';
import LuLandingPageSectionTypeAppResource from './LuLandingPageSectionTypeAppResource';
import LuWorkspaceMembershipTypeAppResource from './LuWorkspaceMembershipTypeAppResource';
import PlaybookAppResource from './PlaybookAppResource';

class LandingPageSellSectionAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'landing-page-sell-section';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'landings/pages/sells/sections';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'landingPageUuid',
      'landingPageSectionTypeId',
      'hasInfo',
      'hasHomeList',
      'hasCashOffer',
      'hasTradeIn',
      'projectMembershipTypeUuid',
      'homeSalePlaybookUuid',
      'landingPage',
      'type',
      'projectMembershipType',
      'playbook',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      landingPage:             LandingPageAppResource,
      type:             LuLandingPageSectionTypeAppResource,
      projectMembershipType:             LuWorkspaceMembershipTypeAppResource,
      playbook:             PlaybookAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      landingPage: 'landing_page_uuid',
      type: 'landing_page_section_type_id',
      projectMembershipType: 'project_membership_type_uuid',
      playbook: 'home_sale_playbook_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      landingPageUuid: {
        type: 'string',
      },
      landingPageSectionTypeId: {
        type: 'integer',
        presence:                 true,
      },
      hasInfo: {
        type: 'boolean',
      },
      hasHomeList: {
        type: 'boolean',
      },
      hasCashOffer: {
        type: 'boolean',
      },
      hasTradeIn: {
        type: 'boolean',
      },
      projectMembershipTypeUuid: {
        type: 'string',
        presence:                 true,
      },
      homeSalePlaybookUuid: {
        type: 'string',
      },
    };
  }

}

export default LandingPageSellSectionAppResource;
